(() => {
  // Product IDs whose owning native forms were audited on DEV, 2026-10-06.
  // Explicit product contract: never infer requirements from titles, templates,
  // brewing methods or Globo's selected coffees. See P3B runtime audit report.
  const required = new Set([
    9966042939637, 9711504523509, 9670681297141, 9670676873461,
    9538270789877, 9538270986485, 9538271215861, 9510332367093, 9510332530933
  ]);
  function normalize(line) {
    if (!required.has(Number(line.product_id))) return 'not_applicable';
    // This exact stored key and these exact values were observed in /cart.js.
    const value = line.properties?.['Grind type'];
    if (value === 'Whole bean') return 'whole_bean';
    if (value === 'Ground') return 'ground';
    return 'invalid';
  }
  window.KaawaCartGrind = Object.freeze({ normalize });
})();
